export default __webpack_public_path__ + "static/media/food_background.87e22c9e.jpg";